import { render } from "./GenerateCustomIDPopup.vue?vue&type=template&id=03c0cbae&scoped=true&ts=true"
import script from "./GenerateCustomIDPopup.vue?vue&type=script&lang=ts"
export * from "./GenerateCustomIDPopup.vue?vue&type=script&lang=ts"

import "./GenerateCustomIDPopup.vue?vue&type=style&index=0&id=03c0cbae&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c0cbae"]])

export default __exports__